/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Unit of the output value of the safety prediction
 */
export enum Unit {
  K_N = 'kN',
  K_NM = 'kNm',
  TONNES = 'tonnes',
  M = 'm',
  DEG = 'deg',
}
